import jsonLogic from 'json-logic-js';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getSplitKey = function getSplitKey(split) {
  return "" + (split.type === 'experiment' ? 'exp.' : 'seg.') + split.id;
};

function getActiveVariation(opts) {
  var splits = opts.splits,
      getKnownValue = opts.getKnownValue,
      updateKnownValue = opts.updateKnownValue;
  var variation = {};
  splits.forEach(function (split) {
    var key = getSplitKey(split);
    var knownVal = getKnownValue(key);

    if (knownVal) {
      variation[key] = knownVal;
      return;
    }

    var numSlices = split.slices.length;
    var chosenSlice = undefined;

    if (split.type === 'experiment') {
      var p = Math.random();
      chosenSlice = split.slices[numSlices - 1];

      for (var i = 0; i < numSlices; i++) {
        if (p - split.slices[i].prob <= 0) {
          chosenSlice = split.slices[i];
          break;
        }

        p -= split.slices[i].prob;
      }
    } else if (split.type === 'segment') {
      for (var _i = 0; _i < numSlices; _i++) {
        if (jsonLogic.apply(split.slices[_i].cond, _extends({
          time: new Date().toISOString()
        }, opts.traits))) {
          chosenSlice = split.slices[_i];
        }
      }
    }

    if (chosenSlice) {
      variation[key] = chosenSlice.id;

      if (split.externalId && chosenSlice.externalId) {
        variation["ext." + split.externalId] = chosenSlice.externalId;
      }

      if (split.type === 'experiment') {
        updateKnownValue(key, chosenSlice.id);
      }
    }
  });
  return variation;
}

export { getActiveVariation, getSplitKey };